import { useState } from 'react';
import {
    Layout as AntLayout,
    Menu,
    Button,
    Badge,
    Drawer,
    Grid,
    Typography,
    Space,
    Input
} from 'antd';
import {
    MenuOutlined,
    ShoppingCartOutlined,
    HeartOutlined,
    SearchOutlined,
    UserOutlined,
    TruckOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header: AntHeader } = AntLayout;
const { useBreakpoint } = Grid;

const Header = () => {
    const navigate = useNavigate();
    const screens = useBreakpoint();
    const [drawerOpen, setDrawerOpen] = useState(false);

    const menuItems = [
        { key: '/', label: 'Главная' },
        { key: '/catalog', label: 'Каталог' },
        { key: '/catalog/smartphones', label: 'Смартфоны' },
        { key: '/catalog/tablets', label: 'Планшеты' },
        { key: '/catalog/laptops', label: 'Ноутбуки' },
        { key: '/delivery', label: 'О доставке' },
        { key: '/contacts', label: 'Контакты' },
    ];

    return (
        <AntHeader style={{
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            padding: '0 24px',
        }}>
            <div className="container" style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%'
            }}>
                {/* Логотип */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: 40,
                        cursor: 'pointer'
                    }}
                    onClick={() => navigate('/catalog')}
                >
                    <TruckOutlined style={{
                        fontSize: 28,
                        color: '#FF6B35',
                        marginRight: 8
                    }} />
                    <Typography.Title
                        level={4}
                        style={{
                            margin: 0,
                            background: 'linear-gradient(90deg, #FF6B35 0%, #1A5FB4 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        ChinaTech
                    </Typography.Title>
                </div>

                {/* Навигация для десктопа */}
                {/*{screens.md ? (*/}
                {/*    <>*/}
                {/*        <Menu*/}
                {/*            mode="horizontal"*/}
                {/*            items={menuItems}*/}
                {/*            onClick={({ key }) => navigate(key)}*/}
                {/*            style={{*/}
                {/*                flex: 1,*/}
                {/*                border: 'none',*/}
                {/*                background: 'transparent'*/}
                {/*            }}*/}
                {/*        />*/}
                {/*        /!*<span>добавитть кнопку связаться с нами</span>*!/*/}
                {/*    </>*/}
                {/*) : (*/}
                {/*    <>*/}
                {/*        <div style={{ flex: 1 }} />*/}
                {/*        <Button*/}
                {/*            type="text"*/}
                {/*            icon={<MenuOutlined />}*/}
                {/*            onClick={() => setDrawerOpen(true)}*/}
                {/*        />*/}
                {/*    </>*/}
                {/*)}*/}
            </div>

            {/* Мобильное меню */}
            <Drawer
                title="Меню"
                placement="left"
                onClose={() => setDrawerOpen(false)}
                open={drawerOpen}
            >
                <Menu
                    mode="vertical"
                    items={menuItems}
                    onClick={({ key }) => {
                        navigate(key);
                        setDrawerOpen(false);
                    }}
                />
            </Drawer>
        </AntHeader>
    );
};

export default Header;